module.exports = __webpack_public_path__ + "img/Trustpilot_ratings_0star_grey-RGB.c0bebca5.svg";